<template>
  <div class="container">
    <section class="w1200">
      <nav>当前位置：<a @click="toHome">期刊</a> > 期刊详情</nav>
      <div class="top flex" :class="{ minheight: !showFlag }" v-if="detail">
        <div class="img_top">
          <div class="img">
            <img :src="detail.cover ? imgUrl + detail.cover : defaultImg" />
          </div>
          <div class="btnList" v-if="!info.ipUser">
            <el-button v-if="!resultFlag" @click="isCollectshow"><i class="el-icon-star-off"></i>收藏</el-button>
            <el-button type="primary" v-else @click="isCollectTips"><i class="el-icon-star-off"></i>取消收藏</el-button>
          </div>
        </div>

        <div class="info">
          <h2>{{ detail.name }}<img v-if="detail.isLibrary == 1" src="../../assets/images/icon-gc.png" /></h2>
          <p v-if="detail.shortName" class="shortName">
            {{ detail.shortName }}
          </p>
          <!-- <p>
            <span class="mr15" v-if="detail.pissn">PISSN: {{ detail.pissn }}</span>
            <span v-if="detail.eissn">EISSN: {{ detail.eissn }}</span>
          </p> -->
          <p>
            <span class="mr15" v-if="detail.issn">ISSN: {{ detail.issn }}</span>
            <!-- <span v-if="detail.eissn">EISSN: {{ detail.eissn }}</span> -->
          </p>
          <p v-if="detail.aliasName">其他刊名：<span v-safe-html="detail.aliasName"></span></p>
          <p>
            <span class="mr15" v-if="detail.cissn">CN号: {{ detail.cissn }}</span>
            <span v-if="detail.doi">DOI: {{ detail.doi }}</span>
          </p>
          <p v-if="detail.publisherName">出版社: {{ detail.publisherName }}</p>
          <p>
            <span class="mr15" v-if="detail.publishDateStart">出版开始日期: {{ detail.publishDateStart }}</span>
            <span v-if="detail.publishDateEnd">出版结束日期: {{ detail.publishDateEnd }}</span>
          </p>
          <p>
            <span class="mr15" v-if="detail.publishCountry"> 出版物国家: {{ detail.publishCountry }} </span>
            <span class="mr15" v-if="detail.publicationType"> 出版物类型: {{ detail.publicationType }} </span>
            <span v-if="detail.publishFrequency"> 出版频率: {{ detail.publishFrequency }} </span>
          </p>
          <p>
            <span class="mr15" v-if="detail.language"> 语种: {{ getString(detail.language) }} </span>
            <span v-if="detail.contentType">内容类型: {{ detail.contentType }}</span>
          </p>
          <p>
            <span class="mr15" v-if="detail.priceType">期刊币种: {{ detail.priceType }}</span>
            <span class="mr15" v-if="detail.priceBook">纸质价格: {{ detail.priceBook }}</span>
            <span class="mr15" v-if="detail.priceEbook">电子价格: {{ detail.priceEbook.toFixed(2) }}</span
            ><span v-if="detail.priceBookEbook">纸+电价格: {{ detail.priceBookEbook.toFixed(2) }}</span>
          </p>
          <p>
            <span class="mr15" v-if="detail.thesaurus"> 主题: {{ getString(detail.thesaurus) }} </span>
            <span class="mr15" v-if="detail.factor">影响因子: {{ detail.factor }}</span>
            <span v-if="detail.coreJournal && detail.coreJournal.length > 0"> 核心期刊: {{ getString(detail.coreJournal) }} </span>
          </p>
          <p v-if="detail.dbRecord">数据库收录: {{ getString(detail.dbRecord) }}</p>
          <p v-if="detail.lcc">LCC分类: {{ getString(detail.lcc) }}</p>
          <p v-if="detail.subjectNames && detail.subjectNames[0]">
            学科分类:
            {{ getString(detail.subjectNames) == "未分类" ? getString(detail.subjectInfo) : getString(detail.subjectNames) }}
          </p>
          <p v-if="detail.foreignSubjectInfo">外文学科分类: {{ detail.foreignSubjectInfo }}</p>
          <p v-if="detail.detailLink">
            期刊详情链接:
            <a @click="toOpen(detail.detailLink)">{{ detail.detailLink }}</a>
          </p>
          <p v-if="detail.attachLink">
            附件下载链接:
            <a @click="toOpen(detail.attachLink)">{{ detail.attachLink }}</a>
          </p>
          <p v-if="detail.doiStore">DOI存储规则: {{ getString(detail.doiStore) }}</p>
          <p>
            <span class="mr15" v-if="detail.edit">编辑: {{ getString(detail.edit) }}</span>
            <!-- <span class="mr15"
              >是否同行评议:
              {{
                detail.peerReview == 1
                  ? "否"
                  : detail.peerReview == 10
                  ? "是"
                  : "未知"
              }}</span
            >
            <span v-if="detail.remark">备注: {{ detail.remark }}</span> -->
          </p>
          <p v-if="detail.brief">简介: {{ detail.brief }}</p>
        </div>
      </div>
      <div class="title" v-if="showFlag">文章列表</div>

      <div class="bottom-info flex" v-if="showFlag">
        <div class="bottom-left">
          <ul v-if="leftLoading" class="left-menu-skeleton" aria-label="期刊聚合加载中">
            <li v-for="item in 6" :key="item" class="left-skeleton-item">
              <span class="skeleton-line left-skeleton-year"></span>
              <span class="skeleton-line left-skeleton-arrow"></span>
            </li>
          </ul>
          <ul v-else class="menu">
            <li v-for="(item, index) in leftData" :key="index" class="menu-one">
              <p @click="showMenuTwo(index)">
                {{ item.year }}
                <i :class="item.checkedFlag ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
              </p>

              <ul class="menu-two" v-show="item.checkedFlag">
                <li :class="{ checked: element.checked }" v-for="(element, idx) in volumeList" :key="idx" @click="handleMenuTwo(index, idx)">
                  {{ element.volumeInfo }}
                </li>
              </ul>
            </li>
          </ul>
          <div class="pagination-controls" v-if="leftTotal > 10">
            <button class="page-btn prev-btn" @click="handlePrevPage" :disabled="year_pageNo <= 1">
              <i class="el-icon-arrow-left"></i>
            </button>
            <span class="page-info">{{ year_pageNo }}/{{ Math.ceil(leftTotal / year_pageSize) }}</span>
            <button class="page-btn next-btn" @click="handleNextPage" :disabled="year_pageNo >= Math.ceil(leftTotal / year_pageSize)">
              <i class="el-icon-arrow-right"></i>
            </button>
          </div>
        </div>
        <div class="bottom-right">
          <div class="total flex">
            <span
              >共<label>{{ listTotal }}</label
              >条记录</span
            >
            <div class="flex br-choice">
              <!-- <div class="sourceType">
                资源来源：
                <el-select v-model="sourceVal" @change="toSearch" placeholder="请选择">
                  <el-option
                    v-for="item in sourceOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </div> -->
              <div class="search flex">
                <el-select v-model="selectVal" placeholder="请选择">
                  <el-option v-for="item in searchOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-input v-model="keyword" placeholder="请输入关键词" @keyup.enter.native="toSearch" clearable></el-input>
                <span class="search_img" @click="toSearch"><img src="../../assets/images/search_icon.png" /></span>
              </div>
            </div>
          </div>
          <ul v-if="loading" class="paper-list-skeleton" aria-label="文章列表加载中">
            <li v-for="item in 5" :key="item" class="paper-skeleton-item">
              <span class="skeleton-line skeleton-index"></span>
              <div class="skeleton-content">
                <span class="skeleton-line skeleton-title"></span>
                <span class="skeleton-line skeleton-meta skeleton-meta-long"></span>
                <span class="skeleton-line skeleton-meta"></span>
                <span class="skeleton-line skeleton-meta skeleton-meta-short"></span>
                <div class="skeleton-footer">
                  <span class="skeleton-line skeleton-count"></span>
                  <span class="skeleton-line skeleton-action"></span>
                  <span class="skeleton-line skeleton-action"></span>
                </div>
              </div>
            </li>
          </ul>
          <ul v-else>
            <li class="flex" v-for="(item, index) in list" :key="index">
              <span class="index">{{ (pageNo - 1) * pageSize + index + 1 }}</span>
              <div class="right-info">
                <!-- <p v-safe-html="item.title" @click="toPaperDetail(item)"></p> -->
                <p @click="toPaperDetail(item)">
                  <span v-safe-html="item.title"></span>
                  <img v-if="item.source == '馆藏资源'" src="../../assets/images/icon-gc.png" />

                  <!-- <label :class="getColor(item.oaType)" v-safe-html="getoatext(item.oaType)"></label> -->
                </p>
                <p v-if="item.authorArray && item.authorArray.length > 0" class="author_p">
                  作者:
                  <span class="span-content" :class="{ green_span: element.click }" v-for="(element, index) in item.authorArray" :key="index">
                    <span class="span_a" @click="toAuthorDetail(element)" v-safe-html="element.authorName"></span>
                    <span class="mr5" v-if="index < item.authorArray.length - 1">;</span>
                    <div class="author-content">
                      <p class="mb10" v-safe-html="element.authorName"></p>
                      <p>
                        <span v-if="element.hindex != null"
                          >hindex：<label>{{ element.hindex }}</label></span
                        >
                        <span v-if="element.i10Index != null"
                          >i10Index：<label>{{ element.i10Index }}</label></span
                        >
                      </p>
                      <p>
                        <span v-if="element.citedByCount != null"
                          >citedByCount：<label>{{ element.citedByCount }}</label></span
                        >
                        <span v-if="element.worksCount != null"
                          >worksCount：<label>{{ element.worksCount }}</label></span
                        >
                      </p>
                      <p class="hui">{{ element.lastKnownInstitutionName }}</p>
                    </div>
                  </span>
                  <label v-if="item.showauthor && item.authorAllArray.length > 5" class="digestLabel" @click="showauthor(index)">展开</label>
                  <label v-if="!item.showauthor" class="digestLabel" @click="closeauthor(index)">收起</label>
                </p>
                <p v-if="item.doi">DOI: <span v-safe-html="item.doi"></span></p>
                <p v-if="item.publisherName">出版社: {{ item.publisherName }}</p>
                <p v-if="item.pageInfo">页码: {{ item.pageInfo }}</p>
                <div class="btn-p flex" @click.stop>
                  <p class="num-tips">
                    引用量<span>{{ item.citedCount }}</span>
                  </p>
                  <div class="btn-right">
                    <div @click.stop class="flex">
                      <div class="btn article-action-active" v-if="roles && item.gainLiteratureState === true && item.source !== '商业资源'" @click="getResource(item, index)" :class="{ noCourse: item.btnLoading }">
                        <img class="rotating-image" v-if="item.btnLoading" src="../../assets/images/loading_s.svg" />
                        <img class="img" src="../../assets/images/icon-qwhq-mr.png" />
                        <img class="hover-img" src="../../assets/images/icon-qwhq-xz.png" />全文获取
                      </div>
                      <div class="achieve" v-if="Resourcelist == item.openAlexId" v-loading="achieveloading" ref="showPanel">
                        <div class="achieve-li">
                          <li v-for="(bookitem, index) in liblist" :key="index" class="1">
                            <a v-safe-html="bookitem.shortName" @click="libdetailUrl(item, bookitem)"></a>
                          </li>
                          <li v-if="gainResource.provideType == '3'" @click="recommendrecord(item)">
                            <a>推荐</a>
                          </li>
                          <li v-if="gainResource.provideType == '2'" @click="getResourceDetail(item, gainResource)">
                            <a>单篇采选</a>
                          </li>
                          <li v-if="gainResource.provideType == '1'" @click="getDeliverSave(item)">
                            <a>文献传递</a>
                          </li>
                          <li v-if="gainResource.provideType == '5'" @click="getLiterature(item)">
                            <a>请求获取</a>
                          </li>
                          <li v-if="paperData.baiduXueShuExist">
                            <a @click="goBaidu(paperData.baiduXueShuLink)">百度学术</a>
                          </li>
                          <li v-if="qingqiuhuoqu">
                            <a @click="getQingqiu(item)">请求获取</a>
                            <!-- <font><i class="el-icon-info"></i>我们在一天内进行处理，请您稍后重新打开界面获取。</font> -->
                          </li>
                          <!-- <ul v-if="gainResource.provideType == '1'">
                            <li v-for="(wxitem, index) in remmendlist" :key="index">
                              <a v-if="wxitem.name != '文献获取'" v-safe-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                              <a v-if="wxitem.name == '文献获取' && item.doi" v-safe-html="wxitem.name" @click="literatureUrl(wxitem.literatureUrl)"></a>
                              <span v-if="wxitem.name == '文献获取'"><i class="el-alert__icon el-icon-warning"></i>一般十分钟获取全文</span>
                              <span v-if="wxitem.name == '百度学术'"><i class="el-alert__icon el-icon-warning"></i>每天免费申请两次</span>
                            </li>
                          </ul> -->
                        </div>
                      </div>
                    </div>
                    <div class="flex article-action-active" @click="copylist(item.sid)">
                      <img src="../../assets/images/icon-fz-mr.png" class="img" />
                      <img src="../../assets/images/icon-fz.png" class="hover-img" />复制
                    </div>
                    <!-- <div class="flex" @click="showReference(item)">
                      <img class="img" src="../../assets/images/icon-yy-mr.png" />
                      <img class="hover-img" src="../../assets/images/icon-yy-xz.png" />引用
                    </div> -->
                    <!-- <div class="flex" :class="{ checked: item.share }" @click="isCollect(item)">
                      <img class="img" :src="item.share ? collectTrue : collectFalse" />
                      <img class="hover-img" src="../../assets/images/icon-sc-xz.png" />收藏
                      <i class="share" v-if="item.shareCount > 0">{{ item.shareCount }}</i>
                    </div> -->
                  </div>
                </div>
              </div>
            </li>
            <el-pagination @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" layout="prev, pager, next" :total="total" hide-on-single-page> </el-pagination>
          </ul>
          <div class="noData" v-if="!loading && total <= 0">
            <img src="../../assets/images/noData.png" />
          </div>
        </div>
      </div>
    </section>
    <state-dialog :stateVal="state" :dialogVisible="stateDialogVisible" :bodyItemDialog="bodyItem" @closeDialog="closeDialog"></state-dialog>
    <el-dialog title="引用" :visible.sync="referenceDialog" width="30%">
      <div class="dialog-content">
        <ul class="dialog-tab">
          <li @click="changeDialogTab(1)" :class="{ dialogChecked: dialogIndex == 1 }">BIB</li>
          <li @click="changeDialogTab(2)" :class="{ dialogChecked: dialogIndex == 2 }">CITE</li>
        </ul>
        <div class="tab1" v-if="dialogIndex == 1">
          <ul>
            <li>
              <p class="flex">
                <span @click="copyContent(BIBObj)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">{{ BIBObj }}</div>
            </li>
          </ul>
        </div>
        <div class="tab1" v-if="dialogIndex == 2">
          <ul>
            <li v-for="(item, index) in CITEArray" :key="index">
              <p class="flex line">
                <label>{{ item.name }}</label>
                <span @click="copyContent(item.value)"> <img src="../../assets/images/icon-fz.png" />复制 </span>
              </p>
              <div class="dialog-info">
                {{ item.value }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        导出为
        <span @click="handleExport('bib')">BibTex</span>
        <span @click="handleExport('endnote')">EndNote</span>
      </span>
    </el-dialog>
    <!-- 将原有的关注对话框替换为收藏对话框 -->
    <el-dialog title="收藏" :visible.sync="referenceCollect" width="30%">
      <div class="follow-btn-box">
        <el-button type="primary" class="follow-btn" @click="handleOnlyFollow"> <i class="el-icon-plus"></i> 收藏期刊 </el-button>
        <el-button type="primary" class="follow-btn subscribe-btn" @click="handleFollowAndSubscribe"> <i class="el-icon-bell"></i> 收藏并订阅期刊 </el-button>
        <el-button class="follow-btn cancel-btn" @click="isCancel"> 取消 </el-button>
      </div>
    </el-dialog>
    <el-dialog title="绑定手机号" :visible.sync="phoneDialog" width="25%">
      <el-input placeholder="请输入手机号" v-model="phone" maxlength="20" @keyup.enter.native="submitAddphone($event)" class="phone-input"></el-input>
      <div class="flex phone">
        <el-input placeholder="验证码" v-model="code" />
        <span class="code" v-if="show" @click="getCode">发送验证码</span>
        <span class="code" v-else>{{ times }}</span>
      </div>
      <div class="flex phonebtn">
        <el-button @click="phoneDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitAddphone">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="请求获取文献" :visible.sync="literatureDialogVisible" width="420px" :before-close="handleLiteratureClose">
      <div class="literature-dialog-content">
        <p class="literature-tip-sm">声明：请求的文献仅用于科研与教学使用，不做非法传播、复制</p>
        <p class="literature-tip">请正确输入邮箱，文献请求获取结果会以邮箱方式通知!</p>

        <el-form :model="literatureForm" :rules="literatureRules" ref="literatureFormRef">
          <el-form-item prop="email">
            <el-input v-model="literatureForm.email" placeholder="请输入邮箱地址" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer-right">
        <el-button @click="handleLiteratureClose">取 消</el-button>
        <el-button type="primary" @click="submitLiterature">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import baseurl from "../../api/baseurl";
import StateDialog from "@/components/state_dialog.vue";
import { oaColor } from "../../assets/js/oacolor";
import { oaText } from "../../assets/js/oacolor";
import Axios from "axios";
export default {
  name: "HomeDetail",
  components: { StateDialog },
  data() {
    return {
      sid: "",
      detail: null,
      imgUrl: "",
      searchOptions: [
        { label: "全部", value: 0 },
        { label: "题名", value: 1 },
        { label: "DOI", value: 2 },
        { label: "作者", value: 3 },
        { label: "作者机构", value: 4 },
      ],
      sourceOptions: [
        { label: "全部", value: "" },
        { label: "商业资源", value: 1 },
        { label: "开放获取", value: 2 },
        { label: "馆藏资源", value: 3 },
      ],
      selectVal: 0,
      sourceVal: 2,
      keyword: "",
      leftData: [],
      list: [],
      pageNo: 1,
      pageSize: 10,
      total: 100,
      listTotal: 0,
      aggFilterObj: null,
      stateDialogVisible: false,
      state: 0,
      bodyItem: null,
      defaultImg: require("../../assets/images/default.png"),
      collectFalse: require("../../assets/images/icon-sc-mr.png"),
      collectTrue: require("../../assets/images/icon-sc-xz.png"),
      resultFlag: false,
      showFlag: true,
      showIndex: 0,
      roles: true,
      Resourcelist: false,
      remmend: false,
      remmendlist: [],
      achieveloading: true,
      detaildoi: "",
      liblist: [],
      Paperstate: "",
      gainResource: {},
      volumeList: [], //年卷期集合
      loading: true,
      dialogIndex: 1,
      BIBObj: null,
      CITEArray: [],
      exportSid: "",
      referenceDialog: false,
      clickIndex: [],
      leftLoading: false,
      qingqiuhuoqu: false,
      referenceCollect: false,
      checkSubscribe: "0", //0：不订阅 1：订阅 默认传0
      phoneDialog: false,
      show: true,
      phone: "",
      code: "",
      times: 60,
      currentResourceItem: null, // 存储当前资源项
      year_pageNo: 1,
      year_pageSize: 10,
      leftTotal: 0, // 左侧菜单数据总条数
      orderField: "publishDate",
      info: {},
      tempSavedVolume: null, // 临时保存的选中卷期
      literatureDialogVisible: false,
      literatureItem: null,
      literatureForm: {
        email: "",
      },
      literatureRules: {
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" },
        ],
      },
      paperData: "",
    };
  },
  mounted() {
    //点击空白关闭弹出
    document.addEventListener("click", this.bodyCloseMenus);
    this.imgUrl = baseurl.fileUrl;
    this.sid = this.$route.query.sid;

    if (localStorage.getItem("roles")) {
      let roleArr = localStorage.getItem("roles").split(",");
      roleArr.forEach(element => {
        if (element == "other") {
          this.roles = false;
        }
      });
    }
    if (sessionStorage.getItem("journalVolumeSelect")) {
      sessionStorage.removeItem("journalVolumeSelect");
    }
    this.getDetail();
    this.getLeftList();
    this.getPaperList();
    this.getInfo();
  },
  methods: {
    getInfo() {
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        this.info = res.data;
      });
    },
    getString(data) {
      if (!data || !data.length) return "";
      return data.toString().split(",").join(" ; ");
    },
    getDetail() {
      this.$http({
        url: "api/v1/reception/journal/detail?journalSid=" + this.sid,
        method: "GET",
      }).then(res => {
        this.detail = res.data;
        if (localStorage.getItem("jyx_token")) {
          // 期刊是否收藏
          this.getShareResult();
        }
      });
    },
    isCollectTips() {
      this.$confirm("是否要取消收藏?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.checkSubscribe = 0;
        this.isCollect();
      });
    },
    // 收藏
    // isCollectshow() {
    //   this.checkSubscribe = "0";
    //   this.referenceCollect = true;
    // },
    isCancel() {
      this.referenceCollect = false;
    },
    // 仅收藏
    handleOnlyFollow() {
      this.checkSubscribe = "0";
      this.isCollect();
    },

    // 收藏并订阅动态
    handleFollowAndSubscribe() {
      this.checkSubscribe = "1";
      this.isCollect();
    },

    // 打开收藏对话框
    isCollectshow(item) {
      this.outSid = item.sid;
      this.checkSubscribe = "0";
      this.referenceCollect = true;
    },

    // 取消收藏
    cancelCollect(item) {
      this.outSid = item.sid;
      this.checkSubscribe = 0;
      this.isCollect();
    },

    // 执行收藏/取消收藏操作
    isCollect() {
      this.referenceCollect = false;
      let postBody = {
        outSid: this.outSid,
        type: 3,
        subscribe: this.checkSubscribe,
      };
      this.$http({
        url: "api/v1/usershare/collect",
        method: "post",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          this.getList();
        }
      });
    },
    isCollect(val) {
      this.referenceCollect = false;
      let postBody = {
        outSid: this.detail.sid,
        type: 1,
        subscribe: this.checkSubscribe,
      };
      this.$http({
        url: `api/v1/usershare/collect`,
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.code == 200) {
          if (res.data == 1) {
            window.location.href = `${baseurl.baseUrl}api/v1/sso/toAuthenticate?redirect=${this.$route.fullPath}`;
          } else {
            if (this.resultFlag) {
              this.$message.success("取消收藏成功");
            } else {
              this.$message.success("收藏成功");
            }
            if (localStorage.getItem("jyx_token")) {
              this.getShareResult();
            }
          }
        }
      });
    },
    getShareResult() {
      let postBody = {
        outSid: this.detail.sid,
        type: 1,
      };
      this.$http({
        url: "api/v1/usershare/shareResult",
        method: "post",
        data: postBody,
      }).then(res => {
        this.resultFlag = res.data;
      });
    },
    toSearch() {
      this.pageNo = 1;
      if (this.keyword.trim()) {
        this.orderField = "_score";
      } else {
        this.orderField = "publishDate";
      }
      this.getPaperList();
    },
    getLeftList() {
      this.leftLoading = true;
      let postBody = {
        journalSid: this.sid,
        pageNo: this.year_pageNo,
        pageSize: this.year_pageSize,
      };
      this.$http({
        url: "/api/v1/reception/journalpaper/volume/year/list2",
        data: postBody,
        method: "post",
      })
        .then(res => {
        this.leftData = [];
        if (res.rows && res.rows.length > 0) {
          // 检查返回数据是否包含总条数信息
          if (res.total) {
            this.leftTotal = res.total;
          } else {
            // 如果没有总条数信息，默认设置为一个较大的值表示有分页
            this.leftTotal = 1000;
          }
          res.rows.forEach(element => {
            this.leftData.push({
              year: element,
              checkedFlag: false, // 初始化展开状态
            });
          });
          // 尝试从sessionStorage恢复选中状态
          const savedSelect = sessionStorage.getItem("journalVolumeSelect");
          if (savedSelect && this.leftData.length > 0) {
            try {
              const selectData = JSON.parse(savedSelect);
              // 找到对应的年份索引
              const yearIndex = this.leftData.findIndex(item => item.year === selectData.year);
              if (yearIndex !== -1) {
                this.tempSavedVolume = selectData;
                // 这里只展开年份，具体卷期的选中状态会在showMenuTwo中恢复
                setTimeout(() => {
                  this.showMenuTwo(yearIndex);
                }, 100);
              }
            } catch (e) {
              console.error("Failed to parse saved selection:", e);
            }
          } else {
            // 默认展开第一个
            // if (this.leftData.length > 0) {
            //   this.showMenuTwo(0);
            // }
          }
        } else {
          this.leftTotal = 0;
        }
        })
        .finally(() => {
          this.leftLoading = false;
        });
    },
    convertToLowercase(str) {
      return str.toUpperCase().toLowerCase();
    },
    getPaperList() {
      this.loading = true;
      let searchFields = this.selectVal == 1 ? ["title"] : this.selectVal == 2 ? ["doi"] : this.selectVal == 3 ? ["author"] : this.selectVal == 4 ? ["authorOrg"] : ["title", "author", "doi", "authorOrg"];
      // 如果输入10. 默认doi搜索
      if (this.keyword.trim().substring(0, 3) == "10.") {
        searchFields = ["doi"];
        //如果输入doi 把大写字母转成小写传给后台
        this.newWord = this.convertToLowercase(this.keyword.trim());
      } else {
        this.newWord = this.keyword.trim();
      }
      let postBody = {
        searchWord: this.newWord,
        searchFields: searchFields,
        source: this.sourceVal,
        journalId: this.id, //期刊id
        journalSid: this.sid, //期刊sid
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        orderField: this.orderField, //固定值
        orderType: "DESC", //固定值
        termFilter: this.aggFilterObj ? [this.aggFilterObj] : [],
      };
      this.$http({
        url: "/api/v1/reception/journalpaper/jpaperlist",
        method: "POST",
        data: postBody,
      }).then(res => {
        this.total = res.data.recordCount > 10000 ? 10000 : res.data.recordCount;
        this.listTotal = res.data.recordCount;
        if (this.total == 0 && this.showIndex == 0) {
          this.showFlag = false;
        }
        this.list = res.data.recordList;
        this.showIndex++;

        this.list.forEach((element, index) => {
          element.isshow = true;
          element.showauthor = true; //作者展开收起标识

          if (element.author) {
            this.$set(this.list[index], "authorAllArray", element.authorList);
            this.$set(this.list[index], "authorArray", element.authorAllArray.slice(0, 5));
          }
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPaperList();
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getPaperList();
    },
    toPaperDetail(item) {
      // let doi = item.doi
      //   .split("<span style='color:red'>")
      //   .join("")
      //   .split("</span>")
      //   .join("");
      const { href } = this.$router.resolve({
        path: `/articleDetail`,
        query: { sid: item.sid },
      });
      window.open(href, "_blank");
      // this.$router.push({ path: "/articleDetail", query: { doi: item.doi } });
    },
    toMine() {
      this.$router.push({ path: "/mine" });
    },
    gethttp(val) {
      if (val.indexOf("http") == 0) {
        return true;
      }
    },
    //获取全文
    getResource(item, index) {
      // 1, “馆藏”
      // 2, “OA”
      // 3, “非馆藏非OA”
      // 5, “采购”
      // 10, “未登录”
      // if (item.source == "馆外资源") {
      //   this.Resourcelist = false;
      //   this.$message.error("馆外无法获取资源");
      //   this.achieveloading = false;
      //   return;
      // }
      if (this.list[index].btnLoading) {
        return;
      }
      this.list[index].btnLoading = true;
      this.$forceUpdate();

      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      let postBody = {
        doi: this.detaildoi,
        openAlexId: item.openAlexId,
      };
      this.$http({
        url: "api/v1/wantbuyR/queryPaper",
        method: "POST",
        data: postBody,
      }).then(res => {
        if (res.data) {
          this.list[index].btnLoading = false;
          this.$forceUpdate();
          this.paperData = res.data;
          this.qingqiuhuoqu = false;
          this.Resourcelist = false;
          this.gainResource = {};
          this.liblist = [];
          if (res.data.state == 1) {
            this.Resourcelist = res.data.openAlexId;
            this.liblist = res.data.ebookNameList;
            this.achieveloading = false;
          } else if (res.data.state == 2) {
            // 显示请求获取按钮
            this.Resourcelist = res.data.openAlexId;
            this.qingqiuhuoqu = true;
            this.achieveloading = false;
          } else if (res.data.state == 3) {
            this.Resourcelist = res.data.openAlexId;
            this.gainResource = res.data.gainResourceBo;
            if (res.data.gainResourceBo.provideType === 4) {
              this.Resourcelist = false;
              this.$message.error("馆外无法获取资源");
              this.achieveloading = false;
              return;
            }
            this.achieveloading = false;
          } else if (res.data.state == 63) {
            window.open(
              `http://lib.cqu.edu.cn/articlesearch/web_searchingResult?key={"rule":{"ruleBody":"DI=[@DI_79107149_0_f]","ruleParameters":[{"key":"@DI_79107149_0_f","value":"${this.detaildoi}"}]},"filterRule":{"ruleBody":"TY=[@TY_96453382_0_f]","ruleParameters":[{"key":"@TY_96453382_0_f","value":"3"}]}}&keyword=${this.detaildoi}`,
            );
          } else if (res.data.state == 5 || res.data.state == 6 || res.data.state == 7) {
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.applyPaperSourceSid}&type=${res.data.state}`,
              method: "get",
            }).then(downres => {
              if (downres.code == 200) {
                // 采购下载
                if (res.data.state == 5) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/purchase/download?uid=" + downres.data);
                }
                // 文献传递下载
                if (res.data.state == 6) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/deliver/download?uid=" + downres.data);
                }
                // 个人上传文件下载
                if (res.data.state == 7) {
                  window.open(baseurl.baseUrl + "api/v1/wantbuyR/person/download?uid=" + downres.data + "&openAlexId=" + res.data.openAlexId);
                }
              }
            });
          } else if (res.data.state == 10) {
            // this.$router.push({ path: "/lg", query: { word: true } });
            this.$message.warning("该资源的全文仅限用户登录后获取，请先登录");
            //  window.open(`/lg?word=true&isback=true`, "_self");
          } else if (res.data.state == 20) {
            //oa附件  下载附件
            this.$http({
              url: `api/v1/wantbuyR/gain?openAlexId=${res.data.openAlexId}&type=${res.data.state}`,
              method: "get",
            }).then(res => {
              if (res.code == 200) {
                window.open(baseurl.baseUrl + "api/v1/wantbuyR/oa/download?uid=" + res.data);
              }
            });
          } else if (res.data.state == 52) {
            let title = "";
            let doi = "";
            if (res.data.doi) {
              doi = res.data.doi;
            } else {
              //个别数据会有\n 去除\n
              if (res.data.title.includes("\n")) {
                title = res.data.title.split("\n").join("");
              } else {
                title = res.data.title;
              }
              doi = title;
            }
            let str = '{"query":{"query_string":{"query":"' + doi + '","default_operator":"AND"}},"track_total_hits":true}';
            let query = encodeURIComponent(str);
            window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
          }
        }
      });
      //非开放获取资源非OA资源
      // if (item.isOa == 1 && item.source == "馆外资源") {
      //   this.Resourcelist = false;
      //   this.Resourcelist = item.sid;
      //   this.$http({
      //     url:
      //       "api/v1/literature/school/gain?doi=" +
      //       this.detaildoi +
      //       "&openAlexId=" +
      //       item.openAlexId,
      //     method: "GET",
      //   }).then((res) => {
      //     if (res.data) {
      //       this.remmend = res.data.isAdvicePurchase;
      //       this.remmendlist = res.data.list;
      //       this.achieveloading = false;
      //     }
      //   });
      // } else {
      //   this.$http({
      //     url: "api/v1/system/ipuser/getIpToken",
      //     method: "GET",
      //   }).then((res) => {
      //     if (res.data) {
      //       localStorage.setItem("token", res.data);
      //       this.getResourceDetail(item);
      //     } else {
      //       this.$router.push({ path: "/lg" });
      //       return;
      //     }
      //   });
      // }
    },
    //推荐
    recommendrecord(item) {
      this.Resourcelist = false;
      this.$http({
        url: "api/v1/advice/record/save/sys?openAlexId=" + item.openAlexId,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("推荐成功");
        } else {
          this.$message.error("推荐失败");
        }
      });
    },
    // 馆藏资源跳转
    libdetailUrl(item, bookItem) {
      this.Resourcelist = false;
      if (item.doi) {
        let doi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        this.detaildoi = doi;
      } else {
        this.detaildoi = "";
      }
      if (bookItem.shortName == "DOAJ-Directory of Open Access Journals") {
        if (!this.detaildoi) {
          this.detaildoi = item.title;
        }
        let str = '{"query":{"query_string":{"query":"' + this.detaildoi + '","default_operator":"AND"}},"track_total_hits":true}';
        let query = encodeURIComponent(str);
        window.open(`https://doaj.org/search/articles?ref=homepage-box&source=${query}`);
        return;
      } else {
        this.$http({
          url: "api/v1/wantbuyR/ebook/link?ebookSid=" + bookItem.sid + "&doi=" + this.detaildoi + "&openAlexId=" + item.openAlexId,
          method: "GET",
        }).then(res => {
          if (res.code == 200) {
            window.open(res.data);
          }
        });
      }
    },
    //跳转外部扩展链接
    literatureUrl(item) {
      if (item.indexOf("apply/paper/resource") > 0) {
        this.getResourceDetail(item);
      } else {
        this.Resourcelist = false;
        window.open(item);
      }
    },
    // 文献传递
    getDeliverSave(item, bitem) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/deliver/apply/sys/save?openAlexId=" + item.openAlexId,
        method: "get",
      }).then(res => {
        window.open(`/asp/myDeliver`, "_self");
        // this.$message.success("文献传递成功，请到个人中心我的文献传递中查看~");
      });
    },
    // 文献请求获取 弹出一个弹框输入邮箱
    getLiterature(item) {
      this.Resourcelist = false;
      this.literatureItem = item;
      this.literatureForm.email = "";
      this.literatureDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.literatureFormRef) {
          this.$refs.literatureFormRef.clearValidate();
        }
      });
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (res.code == 200 && res.data && res.data.email) {
          this.literatureForm.email = res.data.email;
        }
      });
    },
    handleLiteratureClose() {
      this.$refs.literatureFormRef.resetFields();
      this.literatureDialogVisible = false;
    },
    submitLiterature() {
      this.$refs.literatureFormRef.validate(valid => {
        if (!valid) return;
        this.literatureDialogVisible = false;
        this.Resourcelist = false;
        this.$http({
          url: "/api/v1/literature-gain-apply/save",
          method: "POST",
          data: {
            paperSid: this.literatureItem.sid,
            email: this.literatureForm.email,
          },
        }).then(res => {
          if (res.code == 200) {
            this.$message.success("请求获取成功，文献获取通知将发送到您的邮箱");
          }
        });
      });
    },
    // 百度学术
    goBaidu(url) {
      window.open(url);
    },
    // 请求获取
    getQingqiu(item) {
      this.Resourcelist = false;
      this.$http({
        url: "/api/v1/literature-gain-apply/save",
        method: "post",
        data: {
          paperSid: item.sid,
        },
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("请求成功，我们将在一天内进行处理，请您稍后在文献服务平台 - 我的申请 - 我的文献申请中获取!");
          this.qingqiuhuoqu = false;
        }
      });
    },
    getResourceDetail(item) {
      this.Resourcelist = false;
      this.currentResourceItem = item;
      this.$http({
        url: "api/v1/user/info",
        method: "POST",
      }).then(res => {
        if (!res.data.phone) {
          this.code = "";
          this.phone = "";
          clearInterval(this.timer);
          this.show = true;
          this.phoneDialog = true;
          return;
        }
        if (item.doi) {
          this.detaildoi = item.doi.split("<span style='color:red'>").join("").split("</span>").join("");
        } else {
          this.detaildoi = "";
        }
        let postBody = {
          doi: this.detaildoi,
          openAlexId: item.openAlexId,
        };
        this.$http({
          url: "/api/v1/promote/wantbuy/getResource",
          method: "POST",
          data: postBody,
        }).then(res => {
          if (res.data.state == 2) {
            this.$message.success("您已提交过申请");
            return;
          }
          if (res.data.state == 3) {
            this.$message.success("订单是否有对应DOI,订购中");
            return;
          }
          if (res.data.state == 4) {
            this.$message.success("供应商暂不提供该资源");
            return;
          }
          if (res.data.state == 5) {
            this.$message.success("符合采选规则,获取成功");
            return;
          }
          // 不符合采选规则,待申请
          if (res.data.state == 6) {
            // 申请
            let dataBody = {
              doi: res.data.doi,
              title: res.data.title,
              paperPrice: res.data.paperPrice,
              singlePrice: res.data.singlePrice,
              totalPrice: res.data.totalPrice,
              badWord: res.data.badWord,
              supplierId: res.data.supplierId,
            };
            this.$http({
              url: "/api/v1/promote/wantbuy/apply",
              method: "POST",
              data: dataBody,
            }).then(respones => {
              this.$message.success(respones.data);
            });

            return;
          }
          if (res.data.state == 8) {
            //已提交过申请
            this.$message.success("资源被图书馆收录");
            return;
          }
          if (res.data.state == 21) {
            //系统繁忙
            this.$message.error("系统繁忙，请稍后重试");

            return;
          }
          if (res.data.state == 22) {
            //资源申请成功
            this.$message.success("资源申请成功，请在个人申请列表中查看");
            return;
          }
        });
      });
    },
    closeDialog(val) {
      this.stateDialogVisible = val;
    },

    showMenuTwo(index) {
      if (this.leftData[index].checkedFlag) {
        this.$set(this.leftData[index], "checkedFlag", false);
        this.$forceUpdate();
        return;
      }
      this.$http({
        url: "api/v1/reception/journalpaper/volume/detail/List?journalSid=" + this.sid + "&year=" + this.leftData[index].year,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.volumeList = res.data;
          // 检查是否有临时保存的卷期信息需要恢复
          if (this.tempSavedVolume && this.tempSavedVolume.year === this.leftData[index].year) {
            const volumeIndex = this.volumeList.findIndex(item => item.sid === this.tempSavedVolume.volumeSid);
            if (volumeIndex !== -1) {
              // 选中对应的卷期
              this.$set(this.volumeList[volumeIndex], "checked", true);
              this.clickIndex = [index, volumeIndex];
              this.aggFilterObj = {
                filterValue: this.tempSavedVolume.volumeSid,
                filterField: "journalVolumeSid",
              };
              // 清除临时变量
              this.tempSavedVolume = null;
              // 直接调用getPaperList获取对应卷期的论文
              this.getPaperList();
            }
          } else if (this.clickIndex.length > 0) {
            if (index == this.clickIndex[0]) {
              this.$set(this.volumeList[this.clickIndex[1]], "checked", true);
            }
          }

          this.leftData.forEach((element, index) => {
            this.leftData[index].checkedFlag = false;
          });
          this.$set(this.leftData[index], "checkedFlag", true);
        }
      });
    },
    //二级菜单点击事件
    handleMenuTwo(index, idx) {
      this.pageNo = 1;
      if (this.volumeList[idx].checked) {
        this.$set(this.volumeList[idx], "checked", false);
        this.aggFilterObj = null;
        this.clickIndex = [];
        // 清除保存的选中状态
        sessionStorage.removeItem("journalVolumeSelect");
      } else {
        this.volumeList.forEach(element => {
          element.checked = false;
        });
        this.$set(this.volumeList[idx], "checked", true);
        this.clickIndex = [index, idx];
        this.aggFilterObj = {
          filterValue: this.volumeList[idx].sid,
          filterField: "journalVolumeSid",
        };
        // 保存选中状态到sessionStorage
        const savedSelect = {
          year: this.leftData[index].year,
          volumeSid: this.volumeList[idx].sid,
          volumeInfo: this.volumeList[idx].volumeInfo,
        };
        sessionStorage.setItem("journalVolumeSelect", JSON.stringify(savedSelect));
      }
      this.getPaperList();
    },
    // getAssemblyData() {
    //   this.leftData.forEach(element => {
    //     this.$set(element, "checkedFlag", false);
    //     element.volumeList.forEach(ele => {
    //       this.$set(ele, "checked", false);
    //     });
    //   });
    // },
    // 引用
    showReference(item) {
      this.dialogIndex = 1;
      this.exportSid = item.sid;
      this.$http({
        url: `api/v1/reception/journalpaper/getReference?sid=${item.sid}`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.BIBObj = res.data.bib;
          this.CITEArray = [];
          if (res.data.mla) {
            this.CITEArray.push({
              name: "MLA",
              value: res.data.mla,
            });
          }
          if (res.data.apa) {
            this.CITEArray.push({
              name: "APA",
              value: res.data.apa,
            });
          }
          if (res.data.chicago) {
            this.CITEArray.push({
              name: "Chicago",
              value: res.data.chicago,
            });
          }
          if (res.data.gb) {
            this.CITEArray.push({
              name: "GB",
              value: res.data.gb,
            });
          }
          this.referenceDialog = true;
        }
      });
    },
    // 复制
    copyContent(val) {
      this.$copyText(val).then(
        () => {
          this.$message.success("复制成功");
          // 复制成功的操作
        },
        () => {
          this.$message.error("复制失败");
          // 复制失败的操作
        },
      );
    },
    // 导出
    handleExport(type) {
      let url = "";
      if (type == "bib") {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportBibTexReference?sid=" + this.exportSid;
      } else {
        url = baseurl.baseUrl + "/api/v1/reception/journalpaper/exportEndNoteReference?sid=" + this.exportSid;
      }
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
          Authorization: localStorage.getItem("jyx_token"),
        },
        url,
      };

      Axios(options).then(res => {
        let blob = new Blob([res.data]);
        let objectUrl = URL.createObjectURL(blob); //创建下载的链接
        let a = document.createElement("a");
        a.href = objectUrl;

        // 获取文件名
        let fileName = type == "bib" ? "publication.bib" : "publication.enw";
        fileName = decodeURI(fileName);
        a.download = fileName; //设置文件名
        //下面这个写法兼容火狐
        a.dispatchEvent(
          new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );
        window.URL.revokeObjectURL(blob); //释放bolb对象
      });
    },
    changeDialogTab(index) {
      this.dialogIndex = index;
    },

    toHome() {
      sessionStorage.setItem("chongda_home_should_restore", "1");
      this.$router.back();
    },
    toOpen(url) {
      window.open(url);
    },
    bodyCloseMenus(e) {
      if (this.Resourcelist) {
        this.Resourcelist = false;
      }
    },
    beforeDestroy() {
      document.removeEventListener("click", this.bodyCloseMenus);
    },
    // 上一页
    handlePrevPage() {
      if (this.year_pageNo > 1) {
        // 保存当前选中状态
        // if (this.clickIndex.length > 0) {
        //   const savedSelect = {
        //     year: this.leftData[this.clickIndex[0]].year,
        //     volumeSid: this.volumeList[this.clickIndex[1]].sid,
        //     volumeInfo: this.volumeList[this.clickIndex[1]].volumeInfo
        //   };
        //   sessionStorage.setItem('journalVolumeSelect', JSON.stringify(savedSelect));
        // }
        this.year_pageNo--;
        this.getLeftList();
      }
    },
    // 下一页
    handleNextPage() {
      if (this.year_pageNo < Math.ceil(this.leftTotal / this.year_pageSize)) {
        // 保存当前选中状态
        // if (this.clickIndex.length > 0) {
        //   const savedSelect = {
        //     year: this.leftData[this.clickIndex[0]].year,
        //     volumeSid: this.volumeList[this.clickIndex[1]].sid,
        //     volumeInfo: this.volumeList[this.clickIndex[1]].volumeInfo
        //   };
        //   sessionStorage.setItem('journalVolumeSelect', JSON.stringify(savedSelect));
        // }
        this.year_pageNo++;
        this.getLeftList();
      }
    },
    //oa状态
    getColor(item) {
      return oaColor(item);
    },
    getoatext(item) {
      return oaText(item);
    },
    //作者展开收起
    showauthor(index) {
      this.list[index].showauthor = false;
      this.list[index].authorArray = this.list[index].authorAllArray;
      this.$forceUpdate();
    },
    closeauthor(index) {
      this.list[index].showauthor = true;
      this.list[index].authorArray = [];
      for (let i = 0; i < 5; i++) {
        this.list[index].authorArray.push(this.list[index].authorList[i]);
      }
      this.$forceUpdate();
    },
    // 作者详情跳转
    toAuthorDetail(item) {
      if (item.click) {
        let _url = this.$router.resolve({
          path: "/authorDetail",
          query: { authorSid: item.sid },
        });
        window.open(_url.href, "_self");
      }
      // this.$http({
      //   url: `api/v1/reception/author/checkAuthorJumpDetail?authorSid=${authorSid}`,
      //   method: "get",
      // }).then(res => {
      //   setTimeout(() => {
      //     if (res.code == 200) {
      //       if (res.data) {
      //         let _url = this.$router.resolve({
      //           path: "/authorDetail",
      //           query: { authorSid: authorSid },
      //         });
      //         window.open(_url.href, "_blank");
      //       } else {
      //         this.$message.error("该作者暂无收录");
      //       }
      //     }
      //   }, 500);
      // });
    },
    //复制引文
    copylist(id) {
      // 根据当前引文格式获取选中内容
      this.$http({
        url: "api/v1/wantbuyR/copy/context?sid=" + id,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          let copydata = res.data;
          try {
            navigator.clipboard.writeText(copydata).then(() => {
              this.$message.success("已复制,您可随意粘贴使用");
            });
          } catch (err) {
            // 兼容旧浏览器的复制方式
            const textarea = document.createElement("textarea");
            textarea.value = copydata;
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);
            this.$message.success("已复制,您可随意粘贴使用");
          }
        }
      });
    },
    getCode() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      this.$http({
        url: `api/v1/tourist/check/repeat/mobile?mobile=${this.phone}`,
        method: "get",
      }).then(res => {
        if (res.data) {
          this.times = 60;
          let formData = new FormData();
          formData.append("mobilePhone", this.phone);

          this.$http({
            url: `api/v1/user/sendCode`,
            method: "POST",
            data: formData,
          }).then(res => {
            this.show = false;
            this.timer = setInterval(() => {
              this.times--;
              if (this.times === 0) {
                this.show = true;
                clearInterval(this.timer);
              }
            }, 1000);
          });
        } else {
          this.$message.error("该手机号已存在");
          return;
        }
      });
    },
    submitAddphone() {
      if (!this.phone.trim()) {
        this.$message.error("请输入手机号");
        return;
      }
      if (this.phone.length != 11) {
        this.$message.error("手机号不正确");
        return;
      }
      let myreg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/;
      if (!myreg.test(this.phone)) {
        this.$message.error("手机号格式不正确");
        return;
      }
      if (!this.code.trim()) {
        this.$message.error("请输入验证码");
        return;
      }
      let formData = new FormData();
      formData.append("newMobile", this.phone);
      formData.append("smsCode", this.code);
      this.$http({
        url: `api/v1/user/changephone`,
        method: "POST",
        data: formData,
      }).then(res => {
        if (res.code == 200) {
          this.$message.success("绑定成功");
          this.phoneDialog = false;
          // 绑定成功后自动再次调用getResourceDetail方法
          if (this.currentResourceItem) {
            this.getResourceDetail(this.currentResourceItem);
          }
        }
      });
    },
    // 在组件销毁前清除定时器
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.skeleton-line {
  display: block;
  border-radius: 3px;
  background: linear-gradient(90deg, #eef1f5 25%, #f7f8fa 37%, #eef1f5 63%);
  background-size: 400% 100%;
  animation: paper-skeleton-loading 1.4s ease infinite;
}

@keyframes paper-skeleton-loading {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.left-menu-skeleton {
  padding: 0 20px;

  .left-skeleton-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    border-bottom: 1px solid #e6e6e6;
  }

  .left-skeleton-year {
    width: 58%;
    height: 16px;
  }

  .left-skeleton-arrow {
    width: 14px;
    height: 14px;
  }
}

.paper-list-skeleton {
  .paper-skeleton-item {
    display: flex;
    padding: 22px 0;
    border-bottom: 1px dashed #e8ebef;
  }

  .skeleton-index {
    flex: 0 0 30px;
    width: 30px;
    height: 18px;
    margin: 3px 20px 0 0;
  }

  .skeleton-content {
    flex: 1;
    min-width: 0;
  }

  .skeleton-title {
    width: 72%;
    height: 20px;
    margin-bottom: 18px;
  }

  .skeleton-meta {
    width: 52%;
    height: 14px;
    margin-top: 13px;
  }

  .skeleton-meta-long {
    width: 82%;
  }

  .skeleton-meta-short {
    width: 34%;
  }

  .skeleton-footer {
    display: flex;
    align-items: center;
    gap: 24px;
    margin-top: 22px;
    padding-top: 16px;
    border-top: 1px solid #f0f1f3;
  }

  .skeleton-count {
    width: 90px;
    height: 14px;
    margin-right: auto;
  }

  .skeleton-action {
    width: 72px;
    height: 16px;

  }
}

.minheight {
  min-height: calc(100vh - 240px);
  margin-bottom: 20px;
}
.container {
  width: 100%;
  min-height: calc(100vh - 144px);
  .w1200 {
    width: calc(100% - 40px);
    max-width: 1200px;
    min-width: 0;
    nav {
      padding: 20px 0;
      font-size: 14px;
      color: #999999;
    }
    .top {
      background: #fff;
      padding: 30px;
      .img_top {
        margin-right: 20px;
        .btnList {
          margin-top: 20px;
          text-align: left;
          i {
            margin-right: 5px;
          }
        }
      }
      .img {
        width: 200px;
        height: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        border: 1px solid #eeeeee;
        img {
          max-width: 198px;
          max-height: 198px;
        }
      }
      .info {
        color: #666666;
        flex: 1;
        min-width: 0;
        h2 {
          color: #333;
          font-weight: normal;
          font-size: 24px;
          margin-bottom: 10px;
          img {
            margin-left: 10px;
            height: 22px;
            vertical-align: -5px;
          }
        }
        .shortName {
          font-size: 18px;
        }
        p {
          font-size: 16px;
          line-height: 30px;
          a {
            color: #2d8cf0;
          }
          a:hover {
            text-decoration: underline;
          }
        }
      }
    }
    .title {
      background: #2d8cf0;
      color: #fff;
      font-weight: bold;
      padding: 12px 20px;
      margin-top: 20px;
      margin-bottom: 10px;
    }
    .bottom-info {
      margin-bottom: 30px;
      align-items: flex-start;

      .bottom-left {
        width: 250px;
        background: #fff;
        min-height: 200px;
        padding-bottom: 20px;
        .menu {
          .menu-one {
            border-bottom: 1px solid #e6e6e6;
            cursor: pointer;
            &:last-of-type {
              border-bottom: none;
            }
            p {
              padding: 20px;
            }
            i {
              float: right;
              font-size: 20px;
              color: #666;
            }
            .menu-two {
              background: rgba(21, 186, 188, 0.1);
              padding: 0 20px;
              li {
                padding: 15px 0;
                border-bottom: 1px dashed #fff;
                font-size: 14px;
                &:last-of-type {
                  border: none;
                }
              }
              .checked {
                color: #2d8cf0;
              }
            }
          }
        }
        .year-pagination {
          padding: 20px;
          ::v-deep .el-pagination {
            font-size: 12px;
            .el-pagination__total {
              margin-right: 10px;
            }
            .el-pagination__sizes {
              margin-right: 10px;
              .el-input {
                width: 80px;
                .el-input__inner {
                  height: 28px;
                  line-height: 28px;
                }
              }
            }
            .el-pagination__prev,
            .el-pagination__next,
            .el-pagination__jump-prev,
            .el-pagination__jump-next {
              height: 28px;
              line-height: 28px;
              min-width: 28px;
            }
            .el-pagination__page-btn {
              height: 28px;
              line-height: 28px;
              min-width: 28px;
              margin: 0 2px;
            }
            .el-pagination__jump {
              margin-left: 10px;
              .el-input {
                width: 60px;
                margin: 0 5px;
                .el-input__inner {
                  height: 28px;
                  line-height: 28px;
                }
              }
            }
          }
        }
      }
      .bottom-right {
        flex: 1;
        min-width: 0;
        margin-left: 20px;
        .total {
          background: #fff;
          align-items: center;
          padding: 15px 20px;
          margin-bottom: 10px;

          > span {
            label {
              color: #2d8cf0;
              margin: 0 3px;
            }
          }
          .br-choice {
            margin-left: auto;
          }
          .sourceType {
            margin-right: 20px;
            ::v-deep .el-input__inner {
              border-radius: 0;
              height: 32px;
              line-height: 32px;
            }
            ::v-deep .el-input__icon {
              line-height: 32px;
            }
            .el-select {
              width: 140px;
            }
          }
          .search {
            background: #fff;
            border: 1px solid #cccccc;
            width: 400px;
            position: relative;
            ::v-deep .el-input__inner {
              border: none;
              border-radius: 0;
              height: 30px;
              line-height: 30px;
            }
            ::v-deep .el-input__icon {
              line-height: 30px;
            }
            .el-select {
              position: relative;
              width: 100px;
              &::after {
                content: "";
                position: absolute;
                right: 0;
                top: 5px;
                width: 1px;
                height: 20px;
                background: #cccccc;
              }
            }
            .el-input {
              flex: 1;
            }
            .search_img {
              width: 40px;
              height: 30px;
              background: #2d8cf0;
              display: flex;
              align-items: center;
              justify-content: center;
              cursor: pointer;
            }
          }
        }
        ul {
          background: #fff;
          padding: 0 20px;
          li {
            padding: 20px 0;
            border-bottom: 1px dashed #eeeeee;
            .index {
              width: 50px;
              line-height: 30px;
            }
            .right-info {
              color: #666666;
              flex: 1;
              min-width: 0;
              .green {
                color: #2d8cf0;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .mr5 {
                margin-right: 5px;
              }
              .active {
                display: inline-block;
                white-space: nowrap;
                width: 90%;
                overflow: hidden;
                text-overflow: ellipsis;
                vertical-align: bottom;
              }
              .undline {
                color: #2d8cf0;
                cursor: pointer;
                &:hover {
                  text-decoration: underline;
                }
              }
              .btn {
                display: flex;
                align-items: center;
              }
              > p {
                line-height: 30px;
                .fenhao {
                  cursor: pointer;
                  &:hover {
                    text-decoration: underline;
                  }
                  label {
                    cursor: pointer;
                    &:last-of-type {
                      margin: 0 5px;
                    }
                  }
                }
                &:nth-of-type(1) {
                  color: #333;
                  font-size: 18px;
                  font-weight: bold;
                  margin-bottom: 10px;
                  cursor: pointer;
                  img {
                    vertical-align: text-bottom;
                    margin-left: 5px;
                  }
                  label {
                    font-size: 14px;
                    padding-left: 5px;
                    width: 60px;
                    line-height: 22px;
                    text-align: center;
                    color: white;
                    font-weight: initial;
                    padding: 2px 5px;
                    margin-left: 5px;
                  }
                }
                .digestLabel {
                  cursor: pointer;
                  &:hover {
                    color: #2d8cf0;
                  }
                }
              }
              .author_p {
                > span {
                  &:last-of-type {
                    margin-right: 10px;
                  }
                }
              }
              .btn-p {
                align-items: end;
                margin-top: 25px;
                .num-tips {
                  span {
                    // color: #2d8cf0;
                    margin-left: 5px;
                  }
                }
                .share {
                  font-style: normal;
                  color: #2d8cf0;
                  margin-left: 5px;
                }
              }
              .btn-right {
                margin-left: auto;
                display: flex;
                align-items: center;
                .rotating-image {
                  animation: rotate 1s linear infinite;
                }
                @keyframes rotate {
                  from {
                    transform: rotate(0deg);
                  }
                  to {
                    transform: rotate(360deg);
                  }
                }
                img {
                  margin-top: 2px;
                  margin-right: 5px;
                }
                .checked {
                  color: #2d8cf0;
                }
                .noCourse {
                  cursor: default !important;
                }
                .flex {
                  align-items: center;
                  margin-left: 30px;
                  cursor: pointer;
                  position: relative;
                  &:hover {
                    color: #2d8cf0;
                    text-decoration: underline;
                    .hover-img {
                      display: inline-block;
                    }
                    .img {
                      display: none;
                    }
                  }

                  .hover-img {
                    display: none;
                  }
                  &.article-action-active,
                  .article-action-active {
                    color: #2d8cf0;
                    .hover-img {
                      display: inline-block;
                    }
                    .img {
                      display: none;
                    }
                  }
                }
              }
              .span-content {
                position: relative;
                .author-content {
                  top: 30px;
                  left: 0px;
                }
              }
              .green_span {
                cursor: pointer;
                &:hover {
                  .span_a {
                    text-decoration: underline;
                  }
                  transition: all 1s;
                  .author-content {
                    display: inline-block;
                  }
                }
                .span_a {
                  color: #2d8cf0;
                }
              }
              .author-content {
                position: absolute;
                background: #fff;
                box-shadow: 0 0 5px #d3d3d3;
                display: none;
                padding: 10px;
                z-index: 9999;
                top: -30px;
                right: -210px;
                min-width: 300px;
                .mb10 {
                  font-size: 16px;
                  margin-bottom: 10px !important;
                }
                .hui {
                  margin-top: 5px !important;
                  white-space: pre-wrap;
                }
                p {
                  font-size: 14px;
                  margin: 0 !important;
                  line-height: 20px;
                  span {
                    position: relative;
                    &:first-of-type {
                      margin-right: 14px;
                      &::before {
                        content: "";
                        position: absolute;
                        width: 1px;
                        height: 14px;
                        background: #ccc;
                        right: -7px;
                        top: 50%;
                        margin-top: -7px;
                      }
                    }
                    label {
                      color: #2d8cf0;
                    }
                  }
                }
              }
            }
            &:hover {
              .right-info {
                > p {
                  &:nth-of-type(1) {
                    background-image: linear-gradient(to right, #006eb3, #2d8cf0);
                    background-clip: text;
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                    label {
                      -webkit-text-fill-color: initial;
                    }
                  }
                }
              }
            }
            .achieve {
              background: #ffffff;
              border-radius: 2px;
              box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.2);
              position: absolute;
              top: 35px;
              right: 0;
              z-index: 99999;
              cursor: text;
              &::after {
                content: "";
                position: absolute;
                top: -6px;
                right: 10px;
                width: 0;
                height: 0;
                border-left: 8px solid transparent;
                border-right: 8px solid transparent;
                border-bottom: 10px solid #fff; /* 三角形的颜色 */
              }
              .achieve-li {
                min-width: 270px;
                max-width: 700px;
                overflow-y: auto;
                max-height: 200px;
                padding: 15px 20px;
              }

              li {
                font-size: 16px;
                line-height: 28px;
                padding: 0px;
                border-bottom: 0px;
                a {
                  text-decoration: underline;
                  color: #2d8cf0;
                  cursor: pointer;
                }
                font {
                  color: #b3b3b3;
                  font-size: 12px;
                  display: block;
                  line-height: 20px;
                  i {
                    margin-right: 5px;
                    color: #e6a23c;
                  }
                }
                span {
                  font-size: 14px;
                  color: #b3b3b3;
                  margin-left: 5px;
                }
                .el-icon-warning {
                  color: #e6a23c;
                  padding: 0px 10px;
                  width: 30px;
                }
              }
            }
            ::-webkit-scrollbar {
              display: block;
              width: 3px; /* 定制滚动条的宽度 */
            }
            /* 定制滚动条滑块样式 */
            ::-webkit-scrollbar-thumb {
              background-color: #2d8cf0;
            }
            ::-webkit-scrollbar-track {
              background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
            }
          }
        }
      }
    }
  }
  .dialog-wapper {
    color: #333;
    .dialogleft {
      text-align: left;
    }
    p {
      text-align: center;
      font-size: 16px;
      line-height: 30px;
      span {
        color: #2d8cf0;
      }
    }
    .dialog-footer {
      margin-top: 30px;
      text-align: right;
      .el-button {
        border-radius: 0;
      }
    }
  }
  .dialogInfo {
    padding: 0 40px;
    .item {
      align-items: center;
      margin-bottom: 15px;
      font-size: 16px;
      &:last-of-type {
        margin: 0;
      }
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      .el-input {
        flex: 1;
        margin-left: 10px;
      }
      .phone {
        flex: 1;
        position: relative;
        .code {
          position: absolute;
          right: 0;
          height: 40px;
          line-height: 40px;
          color: #2d8cf0;
          padding: 0 20px;
          cursor: pointer;
          &::after {
            content: "";
            position: absolute;
            left: 0;
            width: 1px;
            height: 20px;
            top: 10px;
            background: #cccccc;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: left;
    padding-top: 0;
    padding-bottom: 30px;
    .dialog-footer {
      span {
        width: 80px;
        height: 30px;
        display: inline-block;
        text-align: center;
        line-height: 30px;
        margin-left: 10px;
        cursor: pointer;
        background: #f0f7f7;
        color: #2d8cf0;
        &:hover {
          background: #2d8cf0;
          color: #fff;
        }
      }
    }
  }
  .dialog-content {
    .dialog-tab {
      display: flex;
      align-items: center;
      font-weight: bold;
      color: #333;
      border-bottom: 1px solid #e6e6e6;
      li {
        padding-right: 10px;
        position: relative;
        padding: 0 10px;
        padding-bottom: 5px;
        cursor: pointer;
      }
      .dialogChecked {
        color: #2d8cf0;
        &::before {
          content: "";
          position: absolute;
          bottom: -1px;
          left: 0;
          height: 2px;
          background: #2d8cf0;
          width: 100%;
        }
      }
    }
    .tab1 {
      margin-top: 20px;
      ul {
        max-height: 500px;
        overflow: auto;
        li {
          background: #f7f7f7;
          padding: 30px;
          margin-bottom: 10px;
          &:last-of-type {
            margin: 0;
          }
        }
      }
      ::-webkit-scrollbar {
        display: block;
        width: 8px; /* 定制滚动条的宽度 */
      }
      /* 定制滚动条滑块样式 */
      ::-webkit-scrollbar-thumb {
        background-color: #d9d9d9;
      }
      ::-webkit-scrollbar-track {
        background-color: #f2f2f2; /* 设置滑块以外区域的背景颜色 */
      }

      .flex {
        align-items: center;

        span {
          margin-left: auto;
          cursor: pointer;
          display: flex;
          align-items: center;
          color: #2d8cf0;
        }
      }
      .line {
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 20px;
        label {
          color: #333;
          font-weight: bold;
        }
      }
      img {
        width: 17px;
        height: 16px;
        margin-right: 5px;
      }
      .dialog-info {
        color: #333333;
        line-height: 30px;
        margin-top: 20px;
        font-size: 16px;
        white-space: pre-wrap;
      }
    }
  }
  .digestLabel {
    cursor: pointer;
    &:hover {
      color: #2d8cf0;
    }
  }
}
.btndiv {
  margin-top: 20px;
  text-align: right;
}
::v-deep .el-dialog__body {
  padding: 20px 20px 50px 20px;
}
.phone {
  margin: 20px 0px;
  ::v-deep .el-input {
    .el-input__inner {
      padding-right: 120px;
    }
  }
  align-items: center;
  position: relative;
  .code {
    position: absolute;
    right: 15px;
    padding: 0 20px;
    color: #2d8cf0;
    top: 0;
    line-height: 38px;
    cursor: pointer;
    &::after {
      position: absolute;
      left: 0;
      width: 1px;
      height: 20px;
      background: #c9ebf7;
      content: "";
      top: 10px;
    }
  }
}
.phonebtn {
  display: flex;
  justify-content: flex-end;
}
.bottom-left {
  .pagination-controls {
    display: flex;
    align-items: center;
    margin-left: 30px;
  }

  .page-btn {
    width: 36px;
    height: 36px;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    color: #606266;
    cursor: pointer;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    margin: 0 4px;
    transition: all 0.3s;
  }

  .page-btn:hover:not(:disabled) {
    color: #2d8cf0;
    border-color: #2d8cf0;
  }

  .page-btn:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .page-info {
    margin: 0 8px;
    color: #606266;
    font-size: 14px;
  }

  /* 修复排序选项的样式，确保它们不会被分页控件挤压 */
  .sort-item > p {
    margin-right: 30px;
    font-size: 16px;
    font-weight: bold;
    display: inline-block;
    cursor: pointer;
    position: relative;
    &:hover {
      color: #2d8cf0;
      &::before {
        content: "";
        position: absolute;
        bottom: -21px;
        left: 50%;
        margin-left: -25px;
        height: 2px;
        width: 50px;
        z-index: 88;
        background: #2d8cf0;
      }
    }
  }
}
/* 为收藏对话框添加样式 */
.follow-btn-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  .follow-btn {
    margin: 10px 5px;
    padding: 15px 20px;
    min-width: 220px;
    border-radius: 6px;
    font-size: 14px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  .follow-btn i {
    margin-right: 5px;
  }
  .subscribe-btn {
    background-color: #409eff;
    border-color: #409eff;
  }
  .cancel-btn {
    background-color: #f56c6c;
    border-color: #f56c6c;
    color: white;
  }
}
.literature-dialog-content {
  .literature-tip {
    color: #333;
    font-size: 14px;
    margin-bottom: 10px;
    line-height: 1.6;
  }
  .literature-tip-sm {
    font-size: 12px;
    margin-bottom: 20px;
    color: #ff0000;
  }
}
::v-deep .el-dialog__footer .dialog-footer-right {
  text-align: right;
  display: block;
}

::v-deep .el-dialog {
  max-width: calc(100vw - 32px);
}

@media (max-width: 1024px) {
  .container .w1200 {
    .bottom-info {
      flex-direction: column;

      .bottom-left {
        width: 100%;
        min-height: 0;
        margin-bottom: 12px;

        .menu {
          display: flex;
          flex-wrap: wrap;

          .menu-one {
            flex: 1 1 180px;

            p {
              padding: 14px 16px;
            }
          }
        }

        .pagination-controls {
          justify-content: center;
          margin: 16px 0 0;
        }
      }

      .bottom-right {
        width: 100%;
        margin-left: 0;
      }
    }
  }
}

@media (max-width: 768px) {
  .paper-list-skeleton {
    .paper-skeleton-item {
      padding: 18px 0;
    }

    .skeleton-index {
      flex-basis: 24px;
      width: 24px;
      margin-right: 10px;
    }

    .skeleton-title,
    .skeleton-meta,
    .skeleton-meta-long,
    .skeleton-meta-short {
      width: 90%;
    }

    .skeleton-footer {
      flex-wrap: wrap;
      gap: 12px 16px;
    }

    .skeleton-count {
      margin-right: 0;
    }
  }

  .minheight {
    min-height: 0;
  }

  .container {
    min-height: 100vh;

    .w1200 {
      width: calc(100% - 24px);

      nav {
        padding: 12px 0;
      }

      .top {
        align-items: center;
        flex-direction: column;
        padding: 18px 14px;

        .img_top {
          margin: 0 0 18px;
        }

        .img {
          width: 150px;
          height: 150px;

          img {
            max-width: 148px;
            max-height: 148px;
          }
        }

        .btnList {
          text-align: center;
        }

        .info {
          width: 100%;

          h2 {
            font-size: 21px;
            line-height: 1.5;
            overflow-wrap: anywhere;
          }

          .shortName {
            font-size: 16px;
          }

          p {
            font-size: 14px;
            line-height: 24px;
            overflow-wrap: anywhere;

            span {
              display: inline;
            }

            a {
              overflow-wrap: anywhere;
            }
          }
        }
      }

      .title {
        margin-top: 12px;
      }

      .bottom-info {
        margin-bottom: 16px;

        .bottom-left .menu {
          display: block;
        }

        .bottom-right {
          .total {
            align-items: stretch;
            flex-direction: column;
            gap: 10px;
            padding: 12px;

            .br-choice {
              width: 100%;
              margin-left: 0;
            }

            .search {
              width: 100%;

              .el-select {
                width: 88px;
              }
            }
          }

          > ul {
            padding: 0 12px;

            > li {
              padding: 16px 0;

              > .index {
                width: 32px;
                flex: 0 0 32px;
              }

              .right-info {
                > p {
                  line-height: 24px;
                  overflow-wrap: anywhere;

                  &:nth-of-type(1) {
                    font-size: 16px;
                  }
                }

                .btn-p {
                  align-items: flex-start;
                  flex-direction: column;
                  gap: 10px;
                  margin-top: 16px;
                }

                .btn-right {
                  width: 100%;
                  margin-left: 0;
                  flex-wrap: wrap;
                  gap: 10px 18px;

                  .flex {
                    margin-left: 0;
                  }
                }

                .author-content {
                  left: 0;
                  right: auto;
                  min-width: 0;
                  width: min(300px, calc(100vw - 72px));
                  box-sizing: border-box;
                }
              }

              .achieve {
                left: 0;
                right: auto;
                max-width: calc(100vw - 72px);

                .achieve-li {
                  min-width: 0;
                  max-width: 100%;
                  box-sizing: border-box;
                }
              }
            }
          }
        }
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 18px 16px 30px;
  }

  .dialog-content .tab1 ul li {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .container .w1200 .bottom-info .bottom-right > ul > li > .index {
    display: none;
  }

  .follow-btn-box .follow-btn {
    width: 100%;
    min-width: 0;
  }
}
</style>
